export * from './ConsumerLendingTagline'
